import type { RuleWithPositions } from '@aline/common';
import { getIsPendingAdd, getIsRunnableRule } from '@aline/common';

/** Why a rule in the playbook will not run, for the editor to say so. */
export const RULE_RUN_WARNINGS = {
  noPositions: 'no-positions',
  onlySuggestedPositions: 'only-suggested-positions',
} as const;
export type RuleRunWarning = (typeof RULE_RUN_WARNINGS)[keyof typeof RULE_RUN_WARNINGS];

export const RULE_RUN_WARNING_MESSAGES: Record<RuleRunWarning, string> = {
  [RULE_RUN_WARNINGS.noPositions]: "This rule has no positions, so it won't run. Add a position.",
  [RULE_RUN_WARNINGS.onlySuggestedPositions]:
    "This rule won't run until you accept the suggested position or add one.",
};

/**
 * The warning a rule carries when a run would skip it for want of an accepted
 * position. A rule that is itself a pending add gets none: all of its
 * positions are pending by design, and deciding the rule is what its chip is
 * for.
 */
export function getRuleRunWarning(rule: RuleWithPositions): RuleRunWarning | null {
  if (getIsPendingAdd(rule) || getIsRunnableRule(rule)) return null;

  return rule.positions.length === 0
    ? RULE_RUN_WARNINGS.noPositions
    : RULE_RUN_WARNINGS.onlySuggestedPositions;
}
